import { HouseIcon } from "lucide-react";
import { ReactNode } from "react";
import React from "react";
import { NavLink, UIMatch, useMatches } from "react-router-dom";

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export type RouteMatch = UIMatch<
    unknown,
    { crumb: (data: unknown) => { element: ReactNode; path: string } }
>;

export function RouteBreadcrumbs() {
    const matches = useMatches() as RouteMatch[];

    const crumbItems = matches
        .filter(match => match.handle?.crumb)
        .map(match => match.handle.crumb(match));

    const homeCrumb = {
        path: "/",
        element: <HouseIcon size={16} />,
    };

    const crumbs = [homeCrumb, ...crumbItems];

    return (
        <Breadcrumb className="hidden md:flex">
            <BreadcrumbList>
                {crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (
                        <React.Fragment key={crumb.path}>
                            <BreadcrumbItem>
                                {isLast && crumbs.length > 1 ? (
                                    <span>{crumb.element}</span>
                                ) : (
                                    <BreadcrumbLink asChild>
                                        <NavLink to={crumb.path}>{crumb.element}</NavLink>
                                    </BreadcrumbLink>
                                )}
                            </BreadcrumbItem>
                            {!isLast && <BreadcrumbSeparator />}
                        </React.Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
}
